module.exports = __webpack_public_path__ + "img/103004.6d22155f.png";